import { render, staticRenderFns } from "./BannerSetting.vue?vue&type=template&id=2b58a3e2&scoped=true&"
import script from "./BannerSetting.vue?vue&type=script&lang=js&"
export * from "./BannerSetting.vue?vue&type=script&lang=js&"
import style0 from "./BannerSetting.vue?vue&type=style&index=0&id=2b58a3e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b58a3e2",
  null
  
)

export default component.exports